export const componentName = 'SorterRulePreview';
